import { Box } from '@n26/nxd'
import { LogoLink } from '@components/LogoLink'
import type { AppLocales } from '@constants/i18n'

export function EmptyHeader({ locale }: { locale: AppLocales }) {
  return (
    <header className='px-48 flex items-center justify-center h-[70px] shadow-8 w-full'>
      <Box className='max-w-6xl w-full' display='flex'>
        <LogoLink url={`/${locale}`} />
        <div className='shrink grow' />
        <div className='shrink grow' />
      </Box>
    </header>
  )
}
